import request, { storeRequest } from '@/libs/request';

export const Login = (data) => request('Login', data);
export const Logout = (data) => request('Logout', data);
export const SendSmsCode = (data) => request('SendSmsCode', data);
export const GetManagerLogin = () =>
  storeRequest({ cmd: 'GetManagerLogin' }, { key: 'GetManagerLogin', cache: true });
// 获取管理端登陆方式配置
export const GetManagerLoginConfig = (data = {}) =>
  storeRequest(
    { cmd: 'GetManagerLoginConfig', payload: data },
    { key: 'GetManagerLoginConfig', cache: true },
  );
// 通过企业微信扫码登陆
export const StaffLoginWithWorkwxForManager = (data) =>
  request('StaffLoginWithWorkwxForManager', data);
// 通过okta登录
export const StaffLoginByOIDCForManager = (data) => request('StaffLoginByOIDCForManager', data);
export const LoginPhoneBound = (data) => request('LoginPhoneBound', data);
